import { Pipe, PipeTransform } from '@angular/core';
import {AccountTypes} from "@app/shared/enums/accountTypes.enum";

@Pipe({
  name: 'accountTypeName'
})
export class AccountTypeNamePipe implements PipeTransform {
  transform(value: number | AccountTypes): string {
    switch (value) {
        case 0:
            return 'Admin';
        case 1:
            return 'Work Comp - Case Manager';
        case 2:
            return 'Work Comp - Employer of Work Comp Patient';
        case 3:
            return 'Work Comp - Insurance Adjuster';
        case 4:
            return 'Referral - Referring Clinic';
        default:
            return 'Unknown';
    }
  }
}
